import {
  GET_ALL_USERS,
  GET_SPECIFIC_USER,
  GET_ALL_ROLES,
  GET_ALL_AGENTS,
  GET_ALL_QUEUES,
  GET_ALL_RAMAIS,
  GET_ALL_TAGS,
  GET_ALL_CONFERENCIAS,
  GET_ALL_PESQUISAS,
} from './mutation-types'
import userHttpService from '../_services/userHttpService'

export default {
  listAllUsers: async ({ commit }) => {
    try {
      const response = await userHttpService.getUsers()
      commit(GET_ALL_USERS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },

  listSpecificUser: async ({ commit }, id) => {
    try {
      const response = await userHttpService.getUser(id)
      commit(GET_SPECIFIC_USER, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },

  listAllRoles: async ({ commit }) => {
    try {
      const response = await userHttpService.getRoles()
      commit(GET_ALL_ROLES, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
  listAllQueues: async ({ commit }) => {
    try {
      const response = await userHttpService.getQueues()
      commit(GET_ALL_QUEUES, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
  listAllAgents: async ({ commit }) => {
    try {
      const response = await userHttpService.getAgents()
      commit(GET_ALL_AGENTS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
  listAllRamais: async ({ commit }) => {
    try {
      const response = await userHttpService.getRamais()
      commit(GET_ALL_RAMAIS, response.data.ramais)
    } catch (e) {
      console.log(e.message)
    }
  },
  listAllTags: async ({ commit }) => {
    try {
      const response = await userHttpService.getTAGs()
      commit(GET_ALL_TAGS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
  listAllConferencias: async ({ commit }) => {
    try {
      const response = await userHttpService.getConferencias()
      commit(GET_ALL_CONFERENCIAS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
  listAllPesquisas: async ({ commit }) => {
    try {
      const response = await userHttpService.getPesquisas()
      commit(GET_ALL_PESQUISAS, response.data)
    } catch (e) {
      console.log(e.message)
    }
  },
}
